export const DEFAULT_SEND_SHOP_LOCAL_NOTIFICATION = false;

export const normalizeShopLocalPrizeDescription = (
  prizeDescription: string
): string => prizeDescription.trim().replace(/[.!?]+$/, "");

export const shouldSendShopLocalCampaignNotification = ({
  notificationRequested,
  startDateUtcMilli,
  nowUtcMilli = Date.now(),
}: {
  notificationRequested: boolean;
  startDateUtcMilli: number;
  nowUtcMilli?: number;
}): boolean =>
  notificationRequested &&
  startDateUtcMilli > 0 &&
  startDateUtcMilli <= nowUtcMilli;
